module.exports = __webpack_public_path__ + "img/assign.6aec8ef6.svg";